import React from "react"
import IxForm from "../forms/form"

interface Props {
    formId: string;
    forms: Array<any>;
    returnUrl: string;
    submissionsUrl: string;
    submitColor?: string;
    submitText: string;
    width?: string;
}

export const FormWidget = ({ formId, forms, returnUrl, submissionsUrl, submitText, submitColor, width}: Props) => {

    const form = formId && forms && forms.filter(x => x.formId === formId)[0];

    return (
        <div style={{ maxWidth: width, margin: "auto" }}><IxForm form={form} returnUrl={returnUrl} submissionsUrl={submissionsUrl} submitText={submitText} submitColor={submitColor} className="enquiryFormStyles" /></div>
    );
}

FormWidget.NAME = "FormWidget";
export default FormWidget
